// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .biz-login-banner {
  position: fixed;
  top: 20px;
  right: 0;
  margin-right: 16px;
  z-index: 20;
  animation: fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: 1.5s;
  font-size: 0.875rem;
  padding: 0.125rem;
}
app-root .biz-login-banner .prefix {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .biz-login-banner .sign-in-link {
  display: inline-block;
  font-weight: 600;
  color: #1f1f1f;
}
@media (min-width: 600px) {
  app-root .biz-login-banner .prefix {
    clip: unset;
    clip-path: unset;
    height: unset;
    overflow: unset;
    position: unset;
    white-space: unset;
    width: unset;
  }
}
@media (min-width: 1151px) {
  app-root .biz-login-banner {
    right: 34vw;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Components/BizLogin/BizLoginBanner.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;AALA;EAEI,eAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAMJ;AAjBA;EDOE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACaF;AA1BA;EAkBM,qBAAA;EAEA,gBAAA;EACA,cAAA;AAUN;AAPI;EAAA;IDPF,WAAA;IACA,gBAAA;IACA,aAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;IACA,YAAA;ECkBA;AACF;AAZI;EAAA;IACE,WAAA;EAeJ;AACF;AAZA;EACE;IACE,UAAA;EAcF;EAZA;IACE,UAAA;EAcF;AACF","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../Styles/utilities.less';\n@import '../../Styles/colours.less';\n\napp-root {\n  .biz-login-banner {\n    position: fixed;\n    top: 20px;\n    right: 0;\n    margin-right: 16px;\n    z-index: 20;\n    animation: fadeIn 1s;\n    animation-fill-mode: both;\n    animation-delay: 1.5s;\n    font-size: 0.875rem;\n    padding: 0.125rem;\n\n    .prefix {\n      .visually-hidden-content();\n    }\n\n    .sign-in-link {\n      display: inline-block;\n\n      font-weight: 600;\n      color: @text-black;\n    }\n\n    @media @portraitTabletUp {\n      .prefix {\n        .unset-visually-hidden-content();\n      }\n    }\n\n    @media @desktopUp {\n      right: 34vw;\n    }\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
